export enum BatchSituation {
  STANDING = 1,
  DROPPED = 2,
  CHARGE = 3,
  SPLINTER = 4,
  OTHER = 5
}
